(function () {
  'use strict';

  if (window.kgSfpMobileSlider) return;

  var MOBILE = '(max-width: 749px)';
  var SELECTOR = '[data-kg-sfp-mobile-swiper]';
  var instances = [];

  function entryFor(el) {
    for (var i = 0; i < instances.length; i++) {
      if (instances[i].el === el) return instances[i];
    }
    return null;
  }

  function create(el) {
    var section = el.closest('[data-kg-sfp-section]') || el.parentNode;
    return new Swiper(el, {
      slidesPerView: 1.15,
      spaceBetween: 12,
      watchOverflow: true,
      grabCursor: true,
      navigation: {
        prevEl: section.querySelector('.kg-sfp__nav-btn--prev'),
        nextEl: section.querySelector('.kg-sfp__nav-btn--next')
      }
    });
  }

  function sync() {
    if (typeof Swiper === 'undefined') return;

    var isMobile = window.matchMedia(MOBILE).matches;

    Array.prototype.forEach.call(document.querySelectorAll(SELECTOR), function (el) {
      var entry = entryFor(el);
      var slides = el.querySelectorAll('.swiper-slide').length;

      if (isMobile && slides > 0) {
        if (entry) {
          entry.swiper.update();
        } else {
          instances.push({ el: el, swiper: create(el) });
        }
        return;
      }

      if (entry) {
        entry.swiper.destroy(true, true);
        instances.splice(instances.indexOf(entry), 1);
      }
    });
  }

  function watchViewport() {
    var mq = window.matchMedia(MOBILE);
    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', sync);
    } else if (typeof mq.addListener === 'function') {
      mq.addListener(sync);
    }
  }

  window.kgSfpMobileSlider = { refresh: sync };

  function init() {
    sync();
    watchViewport();
    if (typeof Swiper === 'undefined') window.addEventListener('load', sync);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
